import { Divider, Typography } from '@cobliteam/ui/components';
import type React from 'react';
import TimeRangeSlider from '../TimeRangeSlider';
import type { Boundaries, TimePreset, TimeWindow } from '../types';
import TimePresets from './TimePresets';

interface TimeWindowBodyProps {
  timeWindow: TimeWindow;
  boundaries: Boundaries;
  timePresets: TimePreset[];
  selectedPreset: TimePreset | null;
  showPresets?: boolean;
  onSliderChange: (startTime: string, endTime: string) => void;
  onPresetSelect: (preset: TimePreset) => void;
}

const TimeWindowBody: React.FC<TimeWindowBodyProps> = ({ timeWindow, boundaries, timePresets, selectedPreset, showPresets = true, onSliderChange, onPresetSelect }) => {
  return (
    <div className='flex flex-col gap-4 px-4'>
      <div className='flex flex-col gap-2'>
        <div className='flex items-center justify-between'>
          <Typography variant='text-sm-medium' color='default'>
            Períodos personalizado
          </Typography>
        </div>
        <div className='px-3'>
          <TimeRangeSlider startTime={timeWindow.startTime} endTime={timeWindow.endTime} minTime={boundaries.min} maxTime={boundaries.max} onChange={onSliderChange} />
        </div>
      </div>
      <Divider />
      {showPresets && timePresets.length > 0 && <TimePresets timePresets={timePresets} selectedPreset={selectedPreset} boundaries={boundaries} onPresetSelect={onPresetSelect} />}
    </div>
  );
};

export default TimeWindowBody;
